<template>
    <div
        class="address-card well relative mb-3"
        :class="[isLocalizable(address) ? 'active' : 'disabled', { selected: selected }]"
        @click="selectAddress(address)"
    >
        <h4 class="mt-0">
            {{ address.name }}
            <span class="grey ml-2">
                {{ address.mainAddress ? $l10n.__('Adresse principale') : '' }}
            </span>
        </h4>
        <ul class="m-0">
            <li class="mb-2">{{ address.address_line_1 }}</li>
            <li v-if="address.address_line_2" class="mb-2">{{ address.part2 }}</li>
            <li v-if="address.address_line_2" class="mb-2">{{ address.part3 }}</li>
            <li v-if="address.address_line_4" class="mb-2">{{ address.part4 }}</li>
            <li class="mb-2">{{ address.postal_code }} {{ address.city }}</li>
            <li>{{ address.country_code }}</li>
        </ul>
    </div>
</template>
<script>
export default {
    props: {
        address: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            selected: false,
        };
    },

    methods: {
        isLocalizable(address) {
            return address.geocode?.lat !== null && address.geocode?.lng !== null;
        },

        selectAddress() {
            if (!this.address.geocode?.lat || !this.address.geocode?.lng) {
                Push.error(
                    this.$l10n.__("Cette adresse n'est pas géolocalisable par nos services"),
                );
            } else {
                this.$emit('select-address', this.address, this);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';

.address-card {
    &.disabled {
        color: $gray-60;
    }

    &.active:hover {
        border-color: $gray-100;
        cursor: pointer;
    }

    &.selected {
        border-color: $primary-50;
        border-width: 2px;
    }
}
</style>
